/**
 * Trading Session Mode
 * tag: 339
 * @readonly
 * @enum {number} (int)
 */
export enum TradSesMode {
  /** Testing */
  Testing = 1,
  /** Simulated */
  Simulated = 2,
  /** Production */
  Production = 3,
}
